export const sharedTexts = {
  'shared/components/ChangePasswordModal': {
    passwordPlaceholder: {
      de: 'Neues Passwort',
      'de-DU': 'Neues Passwort',
      en_GB: 'New password',
    },
    cPasswordPlaceholder: {
      de: 'Passwort bestätigen',
      'de-DU': 'Passwort bestätigen',
      en_GB: 'Confirm password',
    },
    resetPassword: {
      de: 'Passwort zurücksetzen',
      'de-DU': 'Passwort zurücksetzen',
      en_GB: 'Reset password',
    },
    changePasswordBtn: {
      de: 'Passwort ändern',
      'de-DU': 'Passwort ändern',
      en_GB: 'Change password',
    },
    msgPassInvalid: {
      de:
        'Ihr neues Passwort muss mindestens 8 Zeichen lang sein und darf keine Leerzeichen enthalten.',
      'de-DU':
        'Ihr neues Passwort muss mindestens 8 Zeichen lang sein und darf keine Leerzeichen enthalten.',
      en_GB:
        'Your password must contain at least 8 characters and must not contain whitespaces.',
    },
    msgPassNotMatching: {
      de: 'Die Passwortfelder stimmen nicht überein',
      'de-DU': 'Die Passwortfelder stimmen nicht überein',
      en_GB: "Password fields don't match",
    },
    passwordChangeSuccess: {
      de: 'Passwort erfolgreich geändert',
      'de-DU': 'Passwort erfolgreich geändert',
      en_GB: 'Changed password successfully',
    },
    passwordChangeFailure: {
      de: 'Passwortänderung gescheitert',
      'de-DU': 'Passwortänderung gescheitert',
      en_GB: 'Password change failed',
    },
    msgRequired: {
      de: 'Feld darf nicht leer sein',
      'de-DU': 'Feld darf nicht leer sein',
      en_GB: 'Field must must not be empty',
    },
    oldPasswordLabel: {
      de: 'Altes Passwort',
      'de-DU': 'Altes Passwort',
      en_GB: 'Old password',
    },
    newPasswordLabel: {
      de: 'Neues Passwort',
      'de-DU': 'Neues Passwort',
      en_GB: 'New password',
    },
    cNewPasswordLabel: {
      de: 'Neues Passwort bestätigen',
      'de-DU': 'Neues Passwort bestätigen',
      en_GB: 'Confirm new',
    },
  },

  'shared/components/FormElements': {
    optionalLabel: {
      de: '(optional)',
      'de-DU': '(optional)',
      en_GB: '(optional)',
      hu: '(opcionális)',
    },
    invalidInput: {
      de: 'Ungültige Eingabe',
      'de-DU': 'Ungültige Eingabe',
      en_GB: 'Invalid input',
      hu: 'Érvénytelen bevitel',
    },
  },

  'shared/components/FormElements/SelectOne': {
    placeholder: {
      de: 'Bitte wählen',
      'de-DU': 'Bitte wählen',
      en_GB: 'Please choose',
      hu: 'Kérlek válassz',
    },
  },
};
